module.exports = __webpack_public_path__ + "static/img/tp.d4eff51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tp.png
// module id = XBQQ
// module chunks = 1